/* eslint-disable */
//packages
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import Immutable from 'immutable'

//form elements
import PaginatorItem from '../../../FormElements/paginatorItem/PaginatorItem'

//common
import SortArrow from '../../../../common/SortArrow'
import NoResults from '../../../../common/NoResults'

//actions
import { searchView } from '../../../../../redux/actions/pacerSearch.js'

//rows
import NatureOfSuitPartiesRow from '../../rows/natureOfSuit/NatureOfSuitPartiesRow.js'
import NatureOfSuitCasesRow from '../../rows/natureOfSuit/NatureOfSuitCasesRow.js'

import BankruptcyPartiesRow from '../../BankruptcyPartiesRow.js'
import BankruptcyCasesRow from '../../BankruptcyCasesRow.js'

import CriminalPartiesRow from '../../CriminalPartiesRow.js'
import CriminalCasesRow from '../../CriminalCasesRow.js'

import CivilPartiesRow from '../../CivilPartiesRow.js'
import CivilCasesRow from '../../CivilCasesRow.js'

//styles
import '../../../../../less/searchResults.less'

class ResultsTable extends Component {
    constructor(props) {
        super(props)

        const active = props.pacerSearchResults.getIn(['searchOptions', 'sort', 'active'])

        this.state = {
            activeField: active ? this.findHeaderFieldBy('key',active.get('field')) : 'Case Title',
            isReverse: active ? active.get('isReverse'): false,
            currentPage: 1
        }
    }

    findHeaderFieldBy = (key, value) =>
        this.props.pacerSearchResults.get('headerFields')
            .find(field => field.get(key) == value).toJS() || {}

    clickSort = (field) => {
        const sortState = {
            activeField: this.findHeaderFieldBy('name', field.name),
            isReverse: (this.state.activeField.name === field.name) ? +(!this.state.isReverse) : 0
        }

        this.setState(sortState, this.doPagingSorting)
    }

    clickPage = (page) => {
        const p = parseInt(page, 10)
        this.setState({currentPage: p}, this.doPagingSorting)
    }

    doPagingSorting() {
        const params = this.props.filters.merge({
            page: this.state.currentPage,
            sort: this.state
        })
        this.props.dispatch(searchView(params))
    }



    render() {
        const searchResultsType = this.props.pacerSearchResults.get('searchResultsType');

        if (searchResultsType == 'empty') return <NoResults/>;

        const pacerSearchResults = this.props.pacerSearchResults
        let pages = pacerSearchResults.getIn(['searchOptions', 'pages']) || null
        let paginatorItems = null
        let previous = null

        //TODO abstract this all into the reducer (except jsx markup code)
        if (!_.isEmpty(pages)) {
            pages = pages.toJS()
            pages = _.sortBy(pages, 'page')
            const page = _.findIndex(pages, {page: this.state.currentPage})

            if (page > -1) {
                pages[page] = Object.assign({}, pages[page], {active: true, url: ""})
            } else {
                pages.splice((this.state.currentPage - 1), 0, { active: true, url: "", page: this.state.currentPage })
            }

            const prevIdx = _.findIndex(pages, {page: 'Previous'})
            if (prevIdx > -1) {
                const prev = pages.splice(prevIdx, 1)[0]
                pages.unshift(prev) //previous is always first element
            } else {
                previous = <li className="pager-previous first">Previous</li>
            }

            //todo - this is overly complicated.  Refactor and move to separate mapper
            paginatorItems = pages.reduce((prev, next, idx) => {
                let prevIdx = prev.idx
                const prevPages = prev.pages
                if (prevIdx > 0 && prevPages[prevIdx-1].page !== 'ellipse' && (next.page - prevPages[prevIdx-1].page) > 1) {
                    prevIdx++
                    prev.pages.push({page: 'ellipse'})
                }

                prevIdx++
                prev.idx = prevIdx
                prev.pages.push(next)

                return prev
            }, {pages: [], idx: 0})

            paginatorItems = paginatorItems.pages.map(item => {
                if (item.page == 'ellipse') {
                    return (<span>...</span>)
                }
                return <PaginatorItem item={ item } clickPage={ this.clickPage }/>
            })
        }

        const data = this.props.pacerSearchResults.get('data')
            ? this.props.pacerSearchResults.get('data').toJS()
            : []

        const RowRenderer = {
                parties: {
                    Bankruptcy:   BankruptcyPartiesRow,
                    Civil:        CivilPartiesRow,
                    Criminal:     CriminalPartiesRow,
                    Appellate: NatureOfSuitPartiesRow,
                },
                cases: {
                    Bankruptcy:   BankruptcyCasesRow,
                    Civil:        CivilCasesRow,
                    Criminal:     CriminalCasesRow,
                    Appellate: NatureOfSuitCasesRow,
                }
        }[searchResultsType][this.props.pacerSearchResults.get('searchType')];

        const caseResults =
            this.props.pacerSearchResults.get('data').toJS()
                .map((result, idx) => <RowRenderer key={idx} meta={result.meta} />)


        let availableSortFields = pacerSearchResults.getIn(['searchOptions', 'sort', 'available'])
        availableSortFields = (availableSortFields) ? availableSortFields.toJS() : []

        let headerFields = null
        if (!_.isEmpty(this.props.pacerSearchResults.get('headerFields'))) {
            const headerFieldsJS = this.props.pacerSearchResults.get('headerFields').toJS()
            headerFields = _.map(headerFieldsJS, (field) => {
                const sortable = _.includes(availableSortFields, field.key)
                return (
                    <th>
                        <span className={`result-header-item ${(sortable) ? 'sortable' : ''}`} onClick={ e => (sortable) ? this.clickSort(field) : null }>
                            { field.name }
                            { (field.name === this.state.activeField.name)
                                ? <SortArrow isReverse={this.state.isReverse}/>
                                : null
                            }
                        </span>
                    </th>
                )
            })
        }

        return (
            <div>
                <div className="item-list">
                    <ul style={{margin: '20px 0 0 0'}} className="pager">
                        { previous }
                        { paginatorItems }
                    </ul>
                </div>
                <div className="search-results">
                    <table className="ir-search-table-results sticky-enabled sticky-table">
                        <thead className="tableHeader-processed">
                            <tr>
                                { headerFields }
                            </tr>
                        </thead>

                        <tbody>
                            { caseResults }
                        </tbody>
                    </table>
                </div>
                <div className="item-list">
                    <ul style={{margin: '20px 0 0 0'}} className="pager">
                        { previous }
                        { paginatorItems }
                    </ul>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        pacerSearchResults: state.get('pacerSearchResults'),
        filters: state.getIn(['pacerSearchResults', 'filters']),
    }
}

export default connect(mapStateToProps)(ResultsTable)



// WEBPACK FOOTER //
// ./src/components/search/results/dataTable/resultsTable/ResultsTable.js